import { httpClient } from '../httpClient/httpClient';

interface Organization {
  id: number;
  enableGarpSync: boolean;
}

export interface UpdateOrgRequest {
  enableGarpSync: boolean;
}

export const organizationApi = {
  get: (orgId: number) =>
    httpClient.get<Organization>(`organizations/${orgId}`),
  update: (orgId: number, data: UpdateOrgRequest) =>
    httpClient.put(`organizations/${orgId}`, { data }),
};
